module.exports = __webpack_public_path__ + "img/avbi07e.1586a668.png";